/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as ShareTokenRouteImport } from './routes/share.$token'
import { Route as StatusPublicIdRouteImport } from './routes/status.$publicId'
import { Route as PublicTargetTargetIdRouteImport } from './routes/public.target.$targetId'
import { Route as AppServicesServiceIdIndexRouteImport } from './routes/_app.services.$serviceId.index'
import { Route as AppServicesServiceIdTargetsTargetIdRouteImport } from './routes/_app.services.$serviceId.targets.$targetId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const StatusPublicIdRoute = StatusPublicIdRouteImport.update({
  id: '/status/$publicId',
  path: '/status/$publicId',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicTargetTargetIdRoute = PublicTargetTargetIdRouteImport.update({
  id: '/public/target/$targetId',
  path: '/public/target/$targetId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppServicesServiceIdIndexRoute =
  AppServicesServiceIdIndexRouteImport.update({
    id: '/services/$serviceId/',
    path: '/services/$serviceId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppServicesServiceIdTargetsTargetIdRoute =
  AppServicesServiceIdTargetsTargetIdRouteImport.update({
    id: '/services/$serviceId/targets/$targetId',
    path: '/services/$serviceId/targets/$targetId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/login': typeof AuthLoginRoute
  '/share/$token': typeof ShareTokenRoute
  '/status/$publicId': typeof StatusPublicIdRoute
  '/public/target/$targetId': typeof PublicTargetTargetIdRoute
  '/services/$serviceId/': typeof AppServicesServiceIdIndexRoute
  '/services/$serviceId/targets/$targetId': typeof AppServicesServiceIdTargetsTargetIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AppDashboardRoute
  '/login': typeof AuthLoginRoute
  '/share/$token': typeof ShareTokenRoute
  '/status/$publicId': typeof StatusPublicIdRoute
  '/public/target/$targetId': typeof PublicTargetTargetIdRoute
  '/services/$serviceId': typeof AppServicesServiceIdIndexRoute
  '/services/$serviceId/targets/$targetId': typeof AppServicesServiceIdTargetsTargetIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_auth/login': typeof AuthLoginRoute
  '/share/$token': typeof ShareTokenRoute
  '/status/$publicId': typeof StatusPublicIdRoute
  '/public/target/$targetId': typeof PublicTargetTargetIdRoute
  '/_app/services/$serviceId/': typeof AppServicesServiceIdIndexRoute
  '/_app/services/$serviceId/targets/$targetId': typeof AppServicesServiceIdTargetsTargetIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/share/$token'
    | '/status/$publicId'
    | '/public/target/$targetId'
    | '/services/$serviceId/'
    | '/services/$serviceId/targets/$targetId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/share/$token'
    | '/status/$publicId'
    | '/public/target/$targetId'
    | '/services/$serviceId'
    | '/services/$serviceId/targets/$targetId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_app/dashboard'
    | '/_auth/login'
    | '/share/$token'
    | '/status/$publicId'
    | '/public/target/$targetId'
    | '/_app/services/$serviceId/'
    | '/_app/services/$serviceId/targets/$targetId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ShareTokenRoute: typeof ShareTokenRoute
  StatusPublicIdRoute: typeof StatusPublicIdRoute
  PublicTargetTargetIdRoute: typeof PublicTargetTargetIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/status/$publicId': {
      id: '/status/$publicId'
      path: '/status/$publicId'
      fullPath: '/status/$publicId'
      preLoaderRoute: typeof StatusPublicIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public/target/$targetId': {
      id: '/public/target/$targetId'
      path: '/public/target/$targetId'
      fullPath: '/public/target/$targetId'
      preLoaderRoute: typeof PublicTargetTargetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/services/$serviceId/': {
      id: '/_app/services/$serviceId/'
      path: '/services/$serviceId'
      fullPath: '/services/$serviceId/'
      preLoaderRoute: typeof AppServicesServiceIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/services/$serviceId/targets/$targetId': {
      id: '/_app/services/$serviceId/targets/$targetId'
      path: '/services/$serviceId/targets/$targetId'
      fullPath: '/services/$serviceId/targets/$targetId'
      preLoaderRoute: typeof AppServicesServiceIdTargetsTargetIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppServicesServiceIdIndexRoute: typeof AppServicesServiceIdIndexRoute
  AppServicesServiceIdTargetsTargetIdRoute: typeof AppServicesServiceIdTargetsTargetIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppServicesServiceIdIndexRoute: AppServicesServiceIdIndexRoute,
  AppServicesServiceIdTargetsTargetIdRoute:
    AppServicesServiceIdTargetsTargetIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ShareTokenRoute: ShareTokenRoute,
  StatusPublicIdRoute: StatusPublicIdRoute,
  PublicTargetTargetIdRoute: PublicTargetTargetIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
